const toSnakeCase = v => v.replace(/\W/g, '_').toLowerCase()
const resolveLinkLocale = link => {
  return link.replace(
    /^(https?:\/\/([\w-]+)\.on-running\.com\/)([a-z]{2}-[a-z]{2}\/)/,
    (...match) => `${match[1]}${On.Store.state.page.locale}/`
  )
}
const resolveLineBreak = str => {
  const words = str.split(/\s/)
  const lastWord = words[words.length - 1]
  const secondLastWord = words[words.length - 2]

  if (words.length > 4 && lastWord.length < 20) {
    return (
      words.slice(0, words.length - 2).join(' ') +
      ` <span class="u-nobr">${secondLastWord} ${lastWord}</span>`
    )
  }
  return str
}
const localizeValue = v => On.helpers.localize(v)
const resolveLineBreakAndLocalizeValue = v => resolveLineBreak(localizeValue(v))

export default {
  toSnakeCase,
  localizeValue,
  resolveLinkLocale,
  resolveLineBreakAndLocalizeValue,
}
